import firebase from 'firebase/compat/app';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function useCodeValidator(
  verificationId,
  resolver = null,
  currentCredentials = null,
  newPhoneUpdate = false
) {
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [code, setCode] = useState(Array(6).fill(''));
  const [loading, setLoading] = useState(false);
  const [userCredentials, setUserCredentials] = useState(null);

  async function validate() {
    setLoading(true);
    setError('');
    try {
      const cred = firebase.auth.PhoneAuthProvider.credential(
        verificationId,
        code.join('')
      );
      const mfAssertion =
        firebase.auth.PhoneMultiFactorGenerator.assertion(cred);

      if (resolver) {
        const firebaseData = await resolver.resolveSignIn(mfAssertion);
        setUserCredentials(firebaseData);
      } else {
        await firebase
          .auth()
          .currentUser.multiFactor.enroll(mfAssertion, 'User phone number');

        if (newPhoneUpdate) {
          navigate('/home');
        }
        if (currentCredentials) {
          setUserCredentials(currentCredentials);
        }
      }
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  }

  return { error, validate, code, setCode, loading, userCredentials };
}

export default useCodeValidator;
